/* eslint-disable no-debugger */
import { map } from 'lodash';
import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

const initialState = {
  isLoading: false,
  error: '',
  isError: false,
  status: true,
  createFileStatus: false,
  masterFileData: [],
  deleteFileSuccess: false
};

const slice = createSlice({
  name: 'filemanager',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },
    // RESET ERROR
    resetMasterFileError(state) {
      state.error = '';
      state.isError = false;
    },
    // RESET DELTE FILE
    resetDeleteFileSuccess(state) {
      state.deleteFileSuccess = false;
    },
    // RESET CREATE STATUS
    resetCreateFileStatus(state) {
      state.createFileStatus = false;
    },
    // HAS ERROR
    hasError(state, action) {
      const { message } = action.payload?.data;
      state.createFileStatus = false;
      state.isLoading = false;
      state.error = message;
      state.isError = true;
    },
    // RESET MASTER FILE DATA
    resetMasterFileData(state) {
      state.masterFileData = [];
    },
    // GET MASTER_FILE
    getMasterFileSuccess(state, action) {
      state.isLoading = false;
      state.masterFileData = action.payload;
    },
    // CREATE MASTER_FILE
    createMasterFileSuccess(state, action) {
      // const newMasterFileData = action.payload;
      state.createFileStatus = true;
      state.isLoading = false;
      // state.masterFileData = [...state.masterFileData, newMasterFileData];
    },
    // DELETE MASTER FILE
    deleteMasterFileSuccess(state, action) {
      const { message } = action.payload;
      state.isLoading = false;
      state.deleteFileSuccess = true;
    },
    // UPDATE_MASTER_FILE
    updateMasterFileSuccess(state, action) {
      const masterFile = action.payload;
      state.createFileStatus = true;
      // const updateMasterFile = map(state.masterFileData, (_masterFile) => {
      //   if (_masterFile.id === masterFile.id) {
      //     return masterFile;
      //   }
      //   return _masterFile;
      // });

      state.isLoading = false;
      // state.masterFileData = updateMasterFile;
    }
  }
});

// Reducer
export default slice.reducer;

// Actions
export const { resetMasterFileError, resetCreateFileStatus, resetDeleteFileSuccess, resetMasterFileData } =
  slice.actions;

// --------------------------------------------------------------------------------

// ----- get MASTER FILE
export function getMasterFileData() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'get',
        url: 'http://smartcollect-api.cp360apps.com/file-management-system/master-file/'
      });
      dispatch(slice.actions.getMasterFileSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

// ----- get Filter MASTER FILE DATA
export function getFilterMasterFileData(filterObj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    dispatch(resetMasterFileData);
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'post',
        url: 'http://smartcollect-api.cp360apps.com/file-management-system/master-file/filter-ids/item/',
        data: filterObj
      });
      dispatch(slice.actions.getMasterFileSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

// ----create MASTER FILE
export function createMasterFileData(fileObj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'post',
        url: 'http://smartcollect-api.cp360apps.com/file-management-system/master-file/',
        data: fileObj
      });
      dispatch(slice.actions.createMasterFileSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}
// http://smartcollect-api.cp360apps.com/file-management-system/master-file/2/

// --- delete Master File
export function deleteMasterFile(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'delete',
        url: `http://smartcollect-api.cp360apps.com/file-management-system/master-file/items/multi-delete/`,
        data: {
          ids: id
        }
      });
      dispatch(slice.actions.deleteMasterFileSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

// http://smartcollect-api.cp360apps.com/file-management-system/master-file/5/
// Update Master File
export function updateMasterFile(MasterFileData, id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'put',
        url: `http://smartcollect-api.cp360apps.com/file-management-system/master-file/${id}/`,
        data: MasterFileData
      });
      dispatch(slice.actions.updateMasterFileSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

// --------------------------------------------------------------------------------
